@if (companies.length > 0) {
  <form [formGroup]="form">
    <!-- Target Company Selection -->
    <div class="form-control-group">
      <label for="company_id" sui-label>Select Target Company</label>
      <sui-combobox
        id="company_id"
        formControlName="company_id"
        [options]="companyOptions"
        placeholder="Select Target Company"
      ></sui-combobox>
    </div>
    <!-- Target User Selection -->
    @if (form.get("company_id")?.value) {
      <div class="form-control-group">
        <label for="target_user_id" sui-label>Select Target User</label>
        <sui-combobox
          id="target_user_id"
          formControlName="target_user_id"
          [options]="(userOptions$ | async) ?? []"
          placeholder="Select Target User"
        ></sui-combobox>
      </div>
    }
    <!-- Select All Toggle -->
    @if (showObjectsSection) {
      <div class="select-all-section">
        <sui-checkbox
          [ngModel]="selectAll"
          [ngModelOptions]="{ standalone: true }"
          (checkedChange)="onSelectAllChange()"
        >
          Select All
        </sui-checkbox>
      </div>
    }
    <!-- Objects Selection Section -->
    @if (showObjectsSection) {
      <div class="objects-section form-group-panel">
        <!-- Feeds Section -->
        @if (groupedObjects.feeds.length > 0) {
          <div class="object-group">
            <h6 class="group-header">Feeds</h6>
            <div class="object-items">
              @for (feed of groupedObjects.feeds; track feed) {
                <sui-checkbox
                  class="object-item"
                  [ngModel]="isObjectSelected(feed.id, 'feeds')"
                  [ngModelOptions]="{ standalone: true }"
                  (checkedChange)="onObjectToggle(feed.id, 'feeds')"
                >
                  <span class="object-title">{{ feed.title }}</span>
                </sui-checkbox>
              }
            </div>
          </div>
        }
        <!-- Dashboards Section -->
        @if (groupedObjects.dashboards.length > 0) {
          <div class="object-group">
            <h6 class="group-header">Dashboards</h6>
            <div class="object-items">
              @for (dashboard of groupedObjects.dashboards; track dashboard) {
                <sui-checkbox
                  class="object-item"
                  [ngModel]="isObjectSelected(dashboard.id, 'dashboards')"
                  [ngModelOptions]="{ standalone: true }"
                  (checkedChange)="onObjectToggle(dashboard.id, 'dashboards')"
                >
                  <span class="object-title">{{ dashboard.title }}</span>
                </sui-checkbox>
              }
            </div>
          </div>
        }
        <!-- Dimensions Section -->
        @if (groupedObjects.dimensions.length > 0) {
          <div class="object-group">
            <h6 class="group-header">Dimensions</h6>
            <div class="object-items">
              @for (dimension of groupedObjects.dimensions; track dimension) {
                <sui-checkbox
                  class="object-item"
                  [ngModel]="isObjectSelected(dimension.id, 'dimensions')"
                  [ngModelOptions]="{ standalone: true }"
                  (checkedChange)="onObjectToggle(dimension.id, 'dimensions')"
                >
                  <span class="object-title">{{ dimension.title }}</span>
                </sui-checkbox>
              }
            </div>
          </div>
        }
      </div>
    }
  </form>
}
